"use client";

import type { BoutiqueIntroProps } from "@/app/directories/shop/[clientSlug]/types";
import { motion } from "framer-motion";
import Image from "next/image";
import { ShopNowButtonComponent } from "../shop-now";
import { BoutiqueShimmerEffect } from "./BoutiqueCanvasEffect";
import { SpinningBoutiqueCircle } from "./BoutiqueSvg";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // Stagger the animations of children
    },
  },
};

// Left section variants - slide in from left
const leftSectionVariants = {
  hidden: {
    x: -100,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring" as const,
      damping: 30,
      stiffness: 200,
    },
  },
};

// Right section variants - slide in from top
const rightSectionVariants = {
  hidden: {
    y: -100,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring" as const,
      damping: 30,
      stiffness: 200,
    },
  },
};

const colorMap = [
  // ["#234621", "#295526", "#A2D99C"],
  ["#243584", "#273BA6", "#99BDF7"],
  // BODY: ["#70351E", "#8A3E22", "#EDBC84"],
];

export const BoutiqueIntroComponent = ({
  props,
}: {
  props: BoutiqueIntroProps;
}) => {
  const { bgImg, title, subtitle } = props;
  return (
    <motion.div
      className="flex lg:flex-row sm:flex-col h-screen lg:p-8 lg:pt-20 lg:pr-0 sm:p-0 sm:pt-14"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="lg:w-3/5 sm:w-full relative h-full sm:hidden lg:block"
        variants={leftSectionVariants}
      >
        <Image
          loading="lazy"
          src={bgImg}
          alt="background Image"
          fill={true}
          className="object-cover rounded-3xl -z-1"
        />
      </motion.div>

      <motion.div
        className="lg:w-2/5 sm:w-full h-full relative"
        variants={rightSectionVariants}
      >
        <div className="flex flex-col h-full justify-between p-10 rounded-3xl backdrop-blur-xl border-l-0">
          <div className="gap-4 flex flex-col">
            <SpinningBoutiqueCircle className="lg:w-32 lg:h-32 sm:w-24 sm:h-24" />

            <p className="config-h1">{title}</p>
            <p className="config-p3 lg:w-3/5 sm:w-full">{subtitle}</p>
          </div>

          <div className="w-full flex justify-end items-end">
            <ShopNowButtonComponent
              isBoutique={true}
              style={"bg-black text-white h-fit"}
            />
          </div>
        </div>

        {/* ShimmerEffect wrapper with its own animation */}
        <motion.div>
          <BoutiqueShimmerEffect
            animationSpeed={3}
            containerClassName="bg-black"
            colors={colorMap[0]}
            dotSize={16}
            insuranceButtonHover={true}
          />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
